export const API_URL = 'https://api.shrtco.de/v2/';
export const TIMEOUT_SEC = 60;
